/* eslint-disable no-underscore-dangle */
import { Partner } from 'types';
import { getPartnerActualShares } from 'utils/filters';

type Eligible = {
  id: string;
  type: 'PARTNER' | 'BENEFICIARY';
  status: 'NOTIFIED' | 'ACCEPTED' | 'REJECTED' | 'CANCELED';
  totalPrice: number;
  totalShares: number;
  operationDate: string;
};

const parsePartnersToEligibles = (
  partnersList: Partner[],
  partners: Partner[]
): Eligible[] => {
  if (!partnersList) {
    return [];
  }

  const eligibles: Eligible[] = partnersList.map((partner) => ({
    id: partner?._id,
    type: 'PARTNER',
    status: 'NOTIFIED',
    totalPrice: 0,
    totalShares: getPartnerActualShares(partner._id, partners),
    operationDate: '',
  }));

  return eligibles;
};

export default parsePartnersToEligibles;
